export const ANALYTICS_SCHEMA_URLS = {
  LOG_CLIENT_ERROR: 'iglu:com.psp/casino_log_client_error/jsonschema/1-0-0',
  PLAY_GAME_CLICK: 'iglu:com.psp/casino_play_game_click/jsonschema/3-0-0',
  ADD_FAVORITE_CLICK: 'iglu:com.psp/casino_add_favorite_click/jsonschema/2-0-0',
  MORE_GAME_CLICK: 'iglu:com.psp/casino_more_game_click/jsonschema/3-0-0',
  ALL_CLASSIFICATION_CLICK:
    'iglu:com.psp/casino_all_classification_click/jsonschema/2-0-0',
  NAVIGATION_CLICK: 'iglu:com.psp/casino_navigation_click/jsonschema/3-0-0',
  DEMO_GAME_CLICK: 'iglu:com.psp/casino_demo_game_click/jsonschema/2-0-0',
  GAME_ACTION: 'iglu:com.psp/casino_game_action/jsonschema/3-0-0',
  CONTEXT_CASINO_PARAMETERS:
    'iglu:com.psp/context_casino_parameters/jsonschema/1-1-0',
  CONTEXT_EVENT_LOCATION:
    'iglu:com.psp/context_event_location/jsonschema/1-2-0',
  BONUS_ACTIONS: 'iglu:com.psp/casino_bonus_item_click/jsonschema/2-0-0',
  DEPOSIT: 'iglu:com.psp/slots_deposit/jsonschema/1-0-0',
  WAGERING_CLICK: 'iglu:com.psp/casino_wagering_click/jsonschema/3-0-0',
};

export const ANALYTICS_SCREEN_NAMES = {
  MAIN: 'instant_main',
  BONUS: 'instant_bonus',
  FAVORITE: 'instant_favorite',
  SEARCH_PAGE: 'instant_search_page',
  OPEN_GAME: 'instant_open_game',
  GAME_PREVIEW: 'instant_game_preview',
  DETAIL_CATEGORY: 'instant_detail_category',
  DETAIL_PROVIDER: 'instant_detail_provider',
  ALL_CATEGORY: 'instant_all_category',
  ALL_PROVIDER: 'instant_all_provider',
  BONUS_WAGERING: 'instant_wagering',
  SITEWIDE_NAVBAR: 'sitewide_navbar',
};

export const ANALYTICS_SCREEN_AREAS = {
  WAGERING_BAR: 'wagering_bar',
  WIDGET: 'widget',
  SIDEBAR: 'sidebar',
  HEADER: 'header',
  SEARCH_RESULTS: 'search_results',
  GAME_WINDOW: 'game_window',
  GAME_LIST: 'game_list',
  BONUS_DETAIL: 'bonus_detail',
  BONUS_TILE_LIST: 'bonus_tile_list',
  CONTROL_TABS: 'control_tabs',
  CATEGORY_LIST: 'category_list',
  PROVIDER_LIST: 'provider_list',
  FAST_SEARCH_INPUT: 'fast_search_input',
  SORT_POP_UP: 'sort_pop_up',
  BUTTON: 'button',
  WIDGET_PWA: 'widget_pwa',
};

export const ANALYTICS_SCREEN_AREA_DETAILS = {
  GO_TO_SEARCH_RESULT: 'go_to_search_result',
  RADIOBUTTON: 'radiobutton',
  SORT_BUTTON: 'sort_button',
  GAME_LIST: 'game_list',
  BUTTON: 'button',
  DEPOSIT_BUTTON: 'deposit_button',
  RANDOM_GAME_SUCCESS: 'category_random_game_success',
  RANDOM_GAME_ERROR: 'category_random_game_error',
  CATEGORY: 'category',
  PROVIDER: 'provider',
  POPULAR_CATEGORY: 'popular_category',
  RECENT_GAME: 'recent_game',
  TOP_GAMES: 'top_games',
  RELEVANCE_GAME: 'relevance_game',
  LATEST_INQUIRIES: 'latest_inquiries',
  CATEGORY_RANDOM_GAME: 'category_random_game',
  CATEGORY_RANDOM_GAME_SUCCESS: 'category_random_game_success',
  CATEGORY_RANDOM_GAME_ERROR: 'category_random_game_error',
  OTHER_PROVIDERS_GAME: 'other_providers_game',
  POPULAR_PROVIDER: 'popular_provider',
  CROSS_SELL: 'cross_sell',
  ALL_GAMES: 'all_games',
  SLIDER: 'slider',
  ALL_CATEGORY: 'all_category',
  ALL_PROVIDER: 'all_provider',
  MAIN_PAGE: 'main_page',
  FAVORITE_PAGE_CLICK: 'favorite_page_click',
  SEARCH_PAGE_CLICK: 'search_page_click',
  FAVORITE_GAMES: 'favorite_games',
  FAST_SEARCH_INPUT: 'fast_search_input',
  SEARCH_INPUT: 'search_input',
  GAME_HEADER: 'game_header',
  GAME_FOOTER: 'game_footer',
  OTHER_GAMES: 'other_games',
  PREVIEW_ACTIONS: 'preview_actions',
  GAME_TILE: 'game_tile',
  CATEGORY_TILE: 'category_tile',
  PROVIDER_TILE: 'provider_tile',
  CROSS_SALE_WIDGET: 'cross_sale_widget',
  GAME_OF_THE_DAY: 'game_of_the_day',
  DOWNLOAD_BUTTON: 'download_button',
  PREVIEW_CURRENCY_CHANGE: 'preview_currency_change',
  BONUS_PAGE_CLICK: 'bonus_page_click',
  CATEGORY_GAMES: 'category_games',
  FREE_SPINS_PAGE_CLICK: 'free_spins_page_click',
  BONUS_TILE: 'bonus_tile',
  BONUS_DETAIL: 'bonus_detail',
  BONUS_BUTTON: 'bonus_button',
  CONTROL_BUTTON: 'control_button',
  CURRENT_MONTH: 'current_month',
  HISTORY_MONTH: 'history_month',
  PREVIEW_LOSS_LIMITS: 'preview_loss_limits',
  WAGERING_BUTTON: 'wagering_button',
  WAGERING_GAMES_PAGE_CLICK: 'wagering_games_page_click',
  RANDOM_GAME: 'random_game',
  PROMO_WIDGET: 'promo_widget',
};

export const ANALYTICS_EVENT_DETAIL = {
  TO_THE_BONUS_DETAIL_CLICK: 'to_the_bonus_detail_click',
  TOP_GAMES: 'top_games',
  REMOVE_FROM_FAVORITE: 'remove_from_favorite',
  RELEVANCE_GAME: 'relevance_game',
  FULLSCREEN: 'fullscreen',
  FULLSCREEN_OFF: 'fullscreen_off',
  CLOSE_GAME: 'close_game',
  PLAY_REAL_GAME: 'play_real_game',
  READ_MORE_RULES: 'read_more_rules',
  OPEN_SORT_CLICK: 'open_sort_click',
  CANCEL: 'cancel',
  APPLY: 'apply',
  BONUS_TILE_CLICK: 'bonus_tile_click',
  HISTORY_BONUS_TILE_CLICK: 'history_bonus_tile_click',
  ACTIVATE_BONUS: 'activate_bonus',
  CANCEL_BONUS_CLICK: 'cancel_bonus_click',
  WAGERING_GAME: 'wagering_game',
  FREESPIN_GAME: 'freespin_game',
  CANCEL_BONUS_CLICK_CONFIRM: 'cancel_bonus_click_confirm',
  CANCEL_BONUS_CLICK_CANCEL: 'cancel_bonus_click_cancel',
  CURRENT: 'current',
  DEPOSIT: 'make_deposit_bonus_click',
  HISTORY: 'history',
};
